export interface StorageDurabilityManagerLike {
	persist?: () => Promise<boolean>;
	persisted?: () => Promise<boolean>;
}

export interface PersistenceRequestFlagStore {
	getItem(key: string): string | null;
	setItem(key: string, value: string): void;
}

export const STORAGE_PERSISTENCE_REQUESTED_KEY = "sw-storage-persistence-requested";

export interface StoragePersistenceResult {
	persisted: boolean;
	requested: boolean;
}

export const persistenceScope = (isStandalone: boolean): string => (isStandalone ? "standalone" : "browser");

const requestStoragePersistence = async (
	storage: StorageDurabilityManagerLike | undefined,
	flagStore: PersistenceRequestFlagStore,
	scope: string
): Promise<StoragePersistenceResult> => {
	if (!storage?.persist || !storage.persisted) return { persisted: false, requested: false };

	const alreadyPersisted = await storage.persisted();
	if (alreadyPersisted) return { persisted: true, requested: false };

	if (flagStore.getItem(STORAGE_PERSISTENCE_REQUESTED_KEY) === scope) return { persisted: false, requested: false };

	const granted = await storage.persist();
	flagStore.setItem(STORAGE_PERSISTENCE_REQUESTED_KEY, scope);
	return { persisted: granted, requested: true };
};

export default requestStoragePersistence;
